import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

interface SEOProps {
    title: string;
    description: string;
    image?: string;
    type?: string;
    date?: string;
}

export const SEO = ({
    title,
    description,
    image,
    type = 'website',
    date
}: SEOProps) => {
    const location = useLocation();
    const siteUrl = 'https://rsatech.com'; // Adjust if there's a different generic base URL
    const currentUrl = `${siteUrl}${location.pathname}`;

    // Default image if none provided - use a branded social card, not the logo
    const metaImage = image ? (image.startsWith('http') ? image : `${siteUrl}${image}`) : `${siteUrl}/digital-strategy-impressive-bg.png`;

    return (
        <Helmet>
            {/* Standard Metadata */}
            <title>{title}</title>
            <meta name="description" content={description} />
            {date && <meta property="article:published_time" content={date} />}

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={currentUrl} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={metaImage} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={currentUrl} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={metaImage} />
        </Helmet>
    );
};
